// extracted by mini-css-extract-plugin
export default {"component":"DisclaimerText_component__YX3p5","text":"DisclaimerText_text__-RJ6X","dark":"DisclaimerText_dark__3dqNj"};